export interface PurchaseOrderReportStockIssues {
  productKey: string;
  stockNo: string;
  reMeasureString: string;
  batch: string;
  warehouse: string;
  location: string;
  quantity: string;
  balance: string;
  unit: string;
  barcode: string;
}
